import {makeVar} from "@apollo/client";

export const getWhitelabel = makeVar(null);

export const setWhitelabel = getWhitelabel;